<template>
	<div id="detail">
		<div class="cent">
			<topinfo></topinfo>
			<page :img="img" :info="info" :iteminfo="iteminfo" @isclick="isclick"></page>
		</div>
		<botinfo></botinfo>
	</div>
</template>

<script>
	import topinfo from 'components/topinfo/topinfo'
	import page from './child/page.vue'
	import botinfo from 'components/botinfo/botinfo'

	import {getdetail} from 'network/detail'


	export default{
		name:'detail',
		data(){
			return{
				iteminfo:[],
        info:[],
        img:[]
			}
		},
		created() {
			document.title = "VR宝箱"+'免费VR资源-VR游戏|VR游戏下载|VR资源下载网|VR资源下载|VR游戏资源下载|VR破解游戏下载|VR游戏下载中心'
      getdetail(this.$route.params.id).then(res =>{
        this.iteminfo.push(...res.data.msg)
        this.info = res.data.msg[0].itempage
        this.img = res.data.msg[0].img
			})
		},
		components:{
			topinfo,
			page,
			botinfo
		},
    methods:{
      isclick(index){
        this.$router.push('/down/'+index)
      }
    }
	}
</script>

<style scoped>
	#detail{
		background: url('https://img.paulzzh.com/touhou/random') no-repeat top;
		height: 100%;
		background-size:100% 100%;
	}
	.cent{
		padding-top: 5px;
		width: 1200px;
		background: #ffffff;
		box-shadow: 0px 0px 5px 5px #c0c0c0;
		margin: auto;
	}
</style>
